export default __webpack_public_path__ + "static/media/plan.7f384f70.svg";